import { createWebHistory, createRouter } from "vue-router";
import { setLocalStorage } from "@/methods/storage";
const Home = () => import("@/views/Home/index.vue");
const About = () => import("@/views/About/index.vue");
const Products = () => import("@/views/Products/index.vue");

const BolearnAI = () => import("@/views/Bolearn/index.vue");

const BolearnAITrain = () => import("@/views/Bolearn/train.vue");
const Solutions = () => import("@/views/Solutions/index.vue");
const Cases = () => import("@/views/Cases/index.vue");
const News = () => import("@/views/News/index.vue");
const NewsDetails = () => import("@/views/NewsDetails/index.vue");
const Contacts = () => import("@/views/Contacts/index.vue");

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/bolearnai",
      name: "BolearnAI",
      component: BolearnAI,
      meta: {
        title: "Bolearn AI平台 - 汉维信息技术",
      },
    },
    {
      path: "/bolearnai-train",
      name: "BolearnAITrain",
      component: BolearnAITrain,
      meta: {
        title: "Bolearn AI陪练 - 汉维信息技术",
      },
    },
    {
      path: "/about",
      name: "About",
      component: About,
    },
    {
      path: "/products",
      name: "Products",
      component: Products,
    },
    {
      path: "/solutions",
      name: "Solutions",
      component: Solutions,
    },
    {
      path: "/cases",
      name: "Cases",
      component: Cases,
    },
    {
      path: "/news",
      name: "News",
      component: News,
    },
    {
      path: "/newsdetail/:id",
      name: "NewsDetail",
      component: NewsDetails,
    },
    {
      path: "/contact",
      name: "Contacts",
      component: Contacts,
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home",
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      // 滚动到顶部
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  setLocalStorage("hanweilink_url", to.path);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
